import { Outlet } from 'react-router-dom';
import { ConvexQueryCacheProvider } from 'convex-helpers/react/cache';
import { AppToaster } from '@ui/components/app-toaster';
import { ConvexClientProvider } from '../providers/ConvexClientProvider';
import { GlobalConfirmDialog } from '../components/GlobalConfirmDialog';

export function RootLayout() {
  return (
    <ConvexClientProvider>
      <ConvexQueryCacheProvider>
        <Outlet />
        <AppToaster />
        <GlobalConfirmDialog />
      </ConvexQueryCacheProvider>
    </ConvexClientProvider>
  );
}
